<template>
<div class="chapter">
<div class="inner_page">
<p class="h2">DRAMATIS PERSONAE</p>
<p class="blocka">It should be noted that in China the surname—here printed in capitals—precedes the personal name</p>
<table>
<colgroup><col width="40%"/>
</colgroup><tbody><tr>
<td valign="top">DEE Jen-djieh</td>
<td valign="top">Magistrate of the district of Poo-yang. In this novel he is staying for a few days with his colleague in the neighbouring district of Chin-hwa</td></tr>
<tr>
<td valign="top">LO Kwan-choong</td>
<td valign="top">Magistrate of the district of Chin-hwa, and amateur poet</td></tr>
<tr>
<td valign="top">KAO Fang</td>
<td valign="top">Counsellor of the tribunal of Chin-hwa</td></tr>
<tr>
<td valign="top">SHAO Fan-wen</td>
<td valign="top">Doctor of Literature, ex-President of the Imperial Academy</td></tr>
<tr>
<td valign="top">CHANG Lan-po</td>
<td valign="top">the Court Poet</td></tr>
<tr>
<td valign="top">Yoo-lan</td>
<td valign="top">a famous poetess</td></tr>
<tr>
<td valign="top">Sexton Loo</td>
<td valign="top">a Zen monk</td></tr>
<tr>
<td valign="top">MENG Su-chai</td>
<td valign="top">a tea-merchant</td></tr>
<tr>
<td valign="top">SOONG I-wen</td>
<td valign="top">a salaried student</td></tr>
<tr>
<td valign="top">Small Phoenix</td>
<td valign="top">a dancing-girl</td></tr>
<tr>
<td valign="top">Saffron</td>
<td valign="top">guardian of the Shrine of the Black Fox</td></tr>
</tbody></table>
<p class="image"><a id="page_viii"></a><img alt="image" src="html/images/a.jpg"/></p>
<p class="image"><a id="page_ix"></a><img alt="image" src="html/images/a1.jpg"/><a id="page_x"></a><a id="page_1"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226848969_07_ch0.vue?61318515